import type { ResumeContext } from '@/pages/SealedVinylPage/lib/resume'

/**
 * 카카오 카드 등록 successURL 복귀(콜백) 쿼리 → resume 결정.
 *
 * 백엔드가 등록 승인 후 `/sealed-vinyl/card-register-callback` 으로 302 redirect 한다:
 *  - 성공: `?paymentMethodId={id}`  → payment 복원 + 그 카드 자동선택
 *  - 취소: `?status=cancel`         → payment 복원 + 취소 토스트
 *  - 실패: `?status=fail`           → payment 복원 + 실패 토스트
 *
 * 어느 경우든 사용자는 결제 흐름 한복판에 있었으므로 PaymentStep 으로 복귀시킨다.
 * 직전 PaymentStep 이 저장해 둔 수량(existing.quantity)은 그대로 보존한다.
 */
export interface CardRegisterCallbackResult {
  resume: ResumeContext
  toastMessage?: string
  /** 카드 등록이 실제로 성공했는지 — true 일 때만 on_payment_method_refresh 브릿지 호출 */
  registered: boolean
}

export function resolveCardRegisterCallback(
  params: URLSearchParams,
  existing: ResumeContext | null,
): CardRegisterCallbackResult {
  const quantity = existing?.quantity

  const paymentMethodId = params.get('paymentMethodId')?.trim()
  if (paymentMethodId) {
    return {
      resume: { step: 'payment', quantity, selectedCardId: paymentMethodId },
      toastMessage: '카드가 등록됐어요',
      registered: true,
    }
  }

  const status = params.get('status')
  if (status === 'cancel') {
    return { resume: { step: 'payment', quantity }, toastMessage: '카드 등록을 취소했어요', registered: false }
  }
  if (status === 'fail') {
    return {
      resume: { step: 'payment', quantity },
      toastMessage: '카드 등록에 실패했어요. 잠시 후 다시 시도해주세요',
      registered: false,
    }
  }

  // 인식 불가/파라미터 없음 — 안전하게 결제 화면으로 복귀(자동선택·토스트 없음)
  return { resume: { step: 'payment', quantity }, registered: false }
}
